<template>
    <div>
        <h5>正在通过微信登录..</h5>
        <!-- <div>
            <van-field v-model="queryCode" placeholder="code" :label-width="100" />
        </div>
        <div>
            <van-field v-model="openId" placeholder="openid" :label-width="100" />
        </div> -->
    </div>
    <div>
        <van-popup v-model:show="showRegistPop" position="bottom" :style="{ height: '30%' }">
            <div style="font-size:16px;margin-top:10%;">
                检测到您还未注册,是否使用微信进行注册?
            </div>
            <div>
                <van-field v-model="errorMsg" placeholder="" :label-width="100" />
            </div>
            <div style="width:100%;margin-top: 4px;">
                <van-button type="success" @click="confirm" style="width:100%;">同意</van-button>
            </div>
            <div style="width:100%;">
                <van-button plain type="success" @click="cancel" style="width:100%;">拒绝</van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { ref } from 'vue';
import { loginWeChatByCode, testWechat, registerByCode } from '../../api/index.js'
import { onMounted } from 'vue';
import { useRoute } from 'vue-router'
import router from '@/router/index.js';
import { Toast } from "@vant/compat";
import store from '@/store/index.js';
import logger from '@/global/logger.js';
import account from '@/api/account.js';

export default {
    setup() {
        let route = useRoute()
        onMounted(() => {
            loginWeChat()
        })

        // 显示底部弹窗
        const showBottom = ref(false)
        let errorMsg = ref('')
        let queryCode = ref('code')

        let openId = ref('openId')

        // 同意注册
        const confirm = () => {
            registerAccount(openId.value)
        }

        // 拒绝
        const cancel = () => {
            showBottom.value = false
            router.push('/')
        }

        // const checkPhoneBindng = async (token) => {
        //     logger.debug("检查是否绑定了手机号...")
        //     let isBinded = await account.isPhoneBinded(token);
        //     logger.debug("返回结果" + JSON.stringify(isBinded, null, 2))
        //     if (!isBinded.value) {
        //         router.push('/bindToPhone')
        //     }
        //     else {
        //         router.push('/')
        //     }
        // };

        // 通过code进入登录
        const loginWeChat = () => {
            const code = route.query.code
            queryCode.value = code;
            const params = { code: code + '', appId: 'wx014c360d9c40c740' }
            //alert(JSON.stringify(params, null, 2))
            loginWeChatByCode(params).then(data => {
                let result = JSON.stringify(data, null, 2)
                //alert(result);
                if (data.isSuccessful) {
                    const token = data.data.token;
                    const userId = data.data.accountId;
                    const hasAccount = data.data.hasAccount;
                    const userName = data.data.nickName;
                    const isMainAccount = data.data.isMainAccount;
                    openId.value = data.data.openId;

                    if (!hasAccount) {
                        showBottom.value = true
                    } else {
                        store.dispatch('login', [userId, token, userName]);
                        Toast.success('登录成功');
                        router.push('/');
                    };
                }
                else {
                    let result = JSON.stringify(data, null, 2)
                    alert(result)
                }
            });
        }

        // 注册 
        const registerAccount = (openId) => {
            const code = route.query.code
            if (openId == undefined) {
                openId = '1'
            }
            const params = { code: code + '', openId: openId, appId: 'wx014c360d9c40c740' }
            registerByCode(params).then(data => {
                let result = JSON.stringify(data, null, 2)
                //alert(result)
                if (data.isSuccessful) {
                    const token = data.data.token;
                    const userId = data.data.accountId;
                    const userName = data.data.nickName;
                    showBottom.value = true;
                    Toast.success('注册成功' + result);
                    store.dispatch('login', [userId, token, userName]);
                    router.push('/')
                } else {
                    showBottom.value = true;
                    Toast.success('注册失败');
                    router.push('/')
                }
            }
            )
        }

        return {
            loginWeChat,
            registerAccount,
            //checkPhoneBindng,
            showRegistPop: showBottom,
            confirm,
            cancel,
            errorMsg,
            queryCode,
            openId
        };

    }
}

</script>